import { AppstoreAddOutlined, BarcodeOutlined, TagsOutlined } from "@ant-design/icons";
import MasterCrudScreen from "./Mastercrudscreen";
import { MASTERS } from "./Masterapi";
import { PURPLE, SKY } from "./Mastertheme";

const config = {
    master: MASTERS.group,
    title: "Item Category Master",
    singular: "Category",
    plural: "Categories",
    subtitle: "Manage item categories and their HSN codes",
    icon: <AppstoreAddOutlined />,
    from: PURPLE,
    to: SKY,
    tips: ["HSN code of the category is auto-filled in Item Master"],
    fields: [
        { name: "groupName", label: "Item Category", placeholder: "e.g. SHIRTS", required: true, icon: <TagsOutlined /> },
        { name: "hsncode", label: "HSN Code", placeholder: "e.g. 6205", icon: <BarcodeOutlined /> },
        { name: "effectdiscount", label: "Effect Discount", type: "switch" },
    ],
};

export default function ItemCategoryMaster() {
    return <MasterCrudScreen config={config} />;
}